import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private userPermissions: string[] | null = null;
  readonly doctorAssistant: string = 'DoctorAssistant'

  constructor() { }

  hasPermission(permission: string): boolean {
    // if (this.userPermissions === null) {
      this.userPermissions = JSON.parse(localStorage.getItem('permissions') ?? '[]');
    // }
    return this.userPermissions?.includes(permission) ?? false;
  }

  isAssistant(): boolean {
    return this.hasPermission(this.doctorAssistant)
  }

  
}
